/*
  OOO Founder Letter LP — page-scoped JS
  Scroll reveal is handled globally by ooo-motion.js (loaded via ooo-head.liquid).
  This file adds:
    1. Auto-stagger for any [data-stagger] containers on this page
    2. Product card subscribe / one-time toggle (if product cards appear)
*/
(function(){
  'use strict';

  // ── 1. Auto-stagger children of [data-stagger] ─────────────────
  document.querySelectorAll('[data-stagger]').forEach(function(parent){
    Array.from(parent.children).forEach(function(child, i){
      if(!child.classList.contains('ooo-reveal')){
        child.classList.add('ooo-reveal');
      }
      child.style.setProperty('--ooo-reveal-delay', i * 80 + 'ms');
    });
  });

  // ── 2. Product card purchase-type toggle ──────────────────────
  document.querySelectorAll('.ooo-pcard').forEach(function(card){
    var opts = card.querySelectorAll('.ooo-pcard__opt');
    opts.forEach(function(opt){
      opt.addEventListener('click', function(){
        opts.forEach(function(o){ o.classList.remove('is-active'); });
        opt.classList.add('is-active');
      });
    });
  });

})();
